import isEmpty from './isEmpty'
import getAdjReason from './getAdjReason'
//-----------------------
// get skill adj reasons
//-----------------------
export default function getSkillAdjReasons({ adjs, type, skill }) {
  console.log('--------------------------')
  console.log('IN getSkillAdjReasons')
  // console.log('ADJS PASSED IN = ', window.$deepCopy(adjs))
  console.log('TYPE PASSED IN = ' + type)
  //----------
  // declares
  //----------
  let source_adjs
  let return_reasons = {}
  let sources_map = ['character', 'characteristic', 'integrated_rune'] // needs to be these value (used within field names)
  //--------------
  // loop sources
  //--------------
  sources_map.forEach((source) => {
    console.log('GETTING REASONS FOR SOURCE = ' + source)
    //-----------------------------------------------------------------------------------------------------------
    // get adjs for this source - where name matches type OR skill name (to cover runecasting + specific skills)
    // ----------------------------------------------------------------------------------------------------------
    source_adjs = adjs.filter(
      (adj) =>
        (adj.name === type || adj.name === skill.display_name || adj.name === skill.name) &&
        adj.source === source,
    )
    console.log('SOURCE ADJS = ', source_adjs)
    //------------------
    // loop source adjs
    //------------------
    source_adjs.forEach((a) => {
      console.log('PROCESSING ADJ reason = ', a.adj_reason, ' / value = ', a.adj_value)
      //------------------------
      // build this adj reasons
      //------------------------
      if (!isEmpty(a.adj_reason)) {
        let reason = getAdjReason(a.adj_reason, a.adj_value)
        // first adj pass
        if (isEmpty(return_reasons[`adjs_reasons_${source}_skill`])) {
          return_reasons[`adjs_reasons_${source}_skill`] = reason
        } else {
          // subsequent adj passes
          return_reasons[`adjs_reasons_${source}_skill`] += '. ' + reason
        }
      }
    })
  })
  return return_reasons
}
